(() => {
  angular
    .module('complianceFrameworkApp.core')
    .filter('trustAsHtml', trustAsHtml);

  /* ngInject */
  function trustAsHtml($sce) {
    return text => {
      return $sce.trustAsHtml(text);
    };
  }
})();
